module.exports = __webpack_public_path__ + "img/wangchai.080ba6ae.png";